module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-empty.e15a93e2.svg";